<template>
    <div>
     <!-- ======= Top Bar ======= -->
     <div id="topbar" class="d-flex align-items-center fixed-top">
            <div class="container d-flex align-items-center justify-content-center justify-content-md-between">
            <div class="align-items-center d-none d-md-flex">
                <i class="bi bi-clock"></i> Monday - Friday, 8AM to 4PM
            </div>
            <div class="d-flex align-items-center">
                
            </div>
            </div>
        </div>
    </div>
</template>
<script>
</script>
